"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var ButtonsGroupContext_1 = require("./ButtonsGroupContext");
function GroupButton(_a) {
    var _b;
    var children = _a.children, className = _a.className, theme = _a.theme, _c = _a.flat, flat = _c === void 0 ? false : _c, _d = _a.active, active = _d === void 0 ? false : _d, _e = _a.onClick, onClick = _e === void 0 ? utils_1.noop : _e, icon = _a.icon, small = _a.small, name = _a.name, others = tslib_1.__rest(_a, ["children", "className", "theme", "flat", "active", "onClick", "icon", "small", "name"]);
    var context = React.useContext(ButtonsGroupContext_1.default);
    var isDisabled = React.useMemo(function () { return context.disabled || others.disabled; }, [context.disabled, others.disabled]);
    var onClickEvent = React.useCallback(function () {
        onClick(name);
        context.onButtonClick && context.onButtonClick(name);
    }, [name]);
    var classes = classnames_1.default(theme.button, className, (_b = {},
        _b[theme.active] = (active || context.activeButtonName === name),
        _b[theme.flat] = flat || context.flat,
        _b[theme.icon] = icon,
        _b[theme.small] = small,
        _b[theme.disabled] = isDisabled,
        _b));
    return (React.createElement("button", tslib_1.__assign({}, others, { name: name, disabled: isDisabled, onClick: onClickEvent, className: classes, type: "button" }), children));
}
exports.default = React.memo(GroupButton);
